import * as React from 'react';
import { useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ProductCategories from './Categories';
import Divider from '@mui/material/Divider';
import { helpAndSettings, trendings } from '../../../../services/dbs/bazzarey_dbs';
import { SET_SELECTED_CATEGORY } from '../../../../store/types/actions/ProductAction';
import ListItemBuilder from '../../../../common/ListItemBuilder';
import { useHistory } from 'react-router-dom';

export default function SideDrawer() {
	const dispatch = useDispatch()
  const history = useHistory()
  const [state, setState] = React.useState({
    left: false
  });

  const toggleDrawer = (open: boolean, item?: any) => (event: any) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, left: open });
    const subcategory = (item && item.subCategory) || ''
    const category = (item && item.selectedCategory) || ''
    dispatch({ type: SET_SELECTED_CATEGORY, payload: { category, subcategory } })
    if(category && subcategory) 
      history.push(`/products/${category}/${subcategory}`)
  };

  const list = () => (
    <Box
      sx={{ width: 300, maxHeight: '100%', overflowY: 'auto' }}
      role="presentation"
    >
      <Box component="h6" mt={3} pl={2}>
        <b>Welcome, Raman</b> <HighlightOffIcon style={{fontSize:'36px'}} onClick={toggleDrawer(false)} />
      </Box>
      <ListItemBuilder title="Trending" data={trendings} toggleDrawer={toggleDrawer} />
      <Divider />
      <ProductCategories title="Shop By Category" toggleDrawer={toggleDrawer} />
      <Divider />
      <ListItemBuilder title="Help and Settings" data={helpAndSettings} toggleDrawer={toggleDrawer} />
    </Box>
  );

  return (
    <React.Fragment>
      <IconButton
        size="large"
        edge="start"
        color="inherit"
        onClick={toggleDrawer(true)}
        aria-label="open drawer"
        sx={{ mr: 0 }}
      >
        <MenuIcon />
      </IconButton>
      <Drawer
        anchor={'left'}
        open={state.left}
        onClose={toggleDrawer(false)}
        >
        {list()}
      </Drawer>
    </React.Fragment>
  );
}
